import { Div } from '@tblabs/truffle';
import { Sensor } from '../../Models/Sensor';


export class SensorBox extends Div
{
    constructor(private sensor: Sensor)
    {
        super();

        this.Class("sensor");
        this.Text(this.sensor.Name);

        this.sensor.Value.OnChange((value: number) => this.Paint(value));
        this.sensor.HasMalfunction.OnChange((hasMalfunction: boolean) => this.SetMalfunction(hasMalfunction), true);
    }

    public Paint(value: number): void
    {
        if (this.sensor.HasMalfunction.value)
        {
            return;
        }
        
        this.Background(value > 0 ? "#f0bf4c" : "none");
        this.Color(value > 0 ? "#444" : "#666");
    }

    public SetMalfunction(hasMalfunction: boolean): void
    {
        if (hasMalfunction)
        {
            this.Text(`${this.sensor.Name} MALFUNCTION`);
            this.Background("red");
            this.Color("white");
        }
    }
}
